import NoGapGroundMountToggle from 'components/tool/Editor/NoGapGroundMountToggle';
import GroundMountToggle from '../../../GroundMountToggle';
import UndoFacetButton from '../UndoButton';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'store';
import ActionStrip from 'components/ModeStrip/Strip';
import { ButtonsWrap, GroundMountWrap, GuideButton } from './style';
import CustomTooltip from 'components/Basic/Tooltip';
import { toggleGuideMode, toggleSnapMode } from 'store/slices/ToolSlice';

export default function DrawModeStrip(){
	const { groundMountEnabled, guideMode, snapMode } = useSelector((state: RootState) => state.toolNewPostions.data);
	const designType = useSelector((state: RootState) => state.roofData.data.designType);
	const solarMode = designType === 'SOLAR';
	const dispatch = useDispatch<AppDispatch>();
	// no keyboard on phones/tablets; a narrow desktop window keeps Guide/Snap
	const isIOSOrAndroid = typeof navigator !== 'undefined' && (
		/iPad|iPhone|iPod|Android/i.test(navigator.userAgent) ||
		(navigator.userAgent.includes('Mac') && navigator.maxTouchPoints > 0) 
	);

	return (
		<ActionStrip
			icon={<svg width="25" height="18" viewBox="0 0 25 18" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M19.6153 10.3085L23.6043 16.9568H1L6.92018 7.64917H10.3077" 
					stroke='var(--defaultIconColor)' strokeWidth="1.69284" strokeLinecap="round" strokeLinejoin="round"/>
				<path d="M19.742 2.29927L21.0413 1L23.1308 3.08948L21.8807 4.33956M19.742 2.29927L12.6834 
					9.35791L11.6387 12.4921L14.7729 11.4474L21.8807 4.33956M19.742 2.29927L21.8807 4.33956" 
				stroke='var(--defaultIconColor)' strokeWidth="1.69284" strokeLinecap="round" strokeLinejoin="round"/>
			</svg>}
			action="Draw Facet"
		>
			<GroundMountWrap>
				<GroundMountToggle />
			</GroundMountWrap>
			{
				(groundMountEnabled && solarMode) && <NoGapGroundMountToggle/>
			}
			{
				!isIOSOrAndroid && (
					<ButtonsWrap>
						<GuideButton
							id="guide-btn"
							$active={guideMode}
							onClick={() => dispatch(toggleGuideMode())}
						>
						Guide
						</GuideButton>
						<GuideButton
							id="snap-btn"
							$active={snapMode}
							onClick={() => dispatch(toggleSnapMode())}
						>
						Snap
						</GuideButton>
						<CustomTooltip elementID="guide-btn" content="Hold Shift" />
						<CustomTooltip elementID="snap-btn" content="Hold Shift + S" />
					</ButtonsWrap>
				)
			}
			<UndoFacetButton />
		</ActionStrip>

	);
}
